import { styled } from 'next-yak'

import * as colors from '../../constants/colors.ts'
import * as fonts from '../../constants/fonts.js'

export const Label = styled.label`
  font-family: ${fonts.PRIMARY_FONT}, sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  color: ${colors.TEXT_PRIMARY};
`

export const Description = styled.span`
  font-family: ${fonts.PRIMARY_FONT}, sans-serif;
  font-weight: 300;
  font-size: 15px;
  line-height: 22px;
  color: ${colors.TEXT_PRIMARY};
`

export const Detail = styled.div`
  font-family: ${fonts.PRIMARY_FONT}, sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: ${(props) => (props.error ? `${colors.SECONDARY_RED_500}` : `${colors.SECONDARY_GREEN_500}`)};
  margin-top: 7px;
`
